module.exports = __webpack_public_path__ + "static/website-icon-b9a28b9f8f6901453fd7e0aadb12e5cb.png";